import {createContext,useContext} from 'react';
import type {Channel} from '../lib/types';
export const ChannelsContext=createContext<{channels:Channel[];reload:()=>void}>({channels:[],reload:()=>{}});
export const useChannels=()=>useContext(ChannelsContext);
export const channelName=(c:Channel)=>{
  const name=c.resource.name;
  if(c.resource.kind==='knowledge'&&(!name||name==='CAP4 Knowledge'))return 'CAP4Knowledge';
  if(c.resource.kind==='organization'&&name==='CAP4 company')return 'CAP4Technologies';
  return name||({person:'Personlig profil',organization:'Virksomhed',knowledge:'CAP4Knowledge'}[c.resource.kind]);
};
